module.exports = __webpack_public_path__ + "img/sw-01.7b2b2cb2.jpg";